import { useResourceContext } from 'react-admin';
import { rbac } from '@utils/rbac';

export const useRbacView = (): boolean => {
  const resource = useResourceContext();

  return rbac.canView(resource);
};
